import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { VALID_USER }   from "apps/action_types";
import { validations }  from "apps/actions/validations";
import { save }         from "apps/actions/common";
import serializeJSON     from 'utilities/serialize_json';
class Form extends BaseAjaxForm {
  validFunction = validations.user;
  submitFunction = save;
  protected setValidations(){
    this.watchAbout('name');
    this.watchAbout('name_alt');
    this.watchAbout('email');
    this.watchAbout('password');
    this.watchAbout('password_confirmation');
    for(let key in this.opts.inputs.role.items){
      this.watchAbout('role.items.' + key, this.onChangeRole);
    }
  }
  // validations
  public onChangeRole(newVal: any, oldVal: any, objectPath: string){
    this.dispatchValidation(newVal, 'role');
  }
}

riot.mixin('forms.users.save', Form as riot.TagMixin)
